import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import { School } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../context/appContext";

function KsbItAppBarTitle() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { isAuthenticated, currentUser, isMobile } = useAppContext();

  const isLoggedIn = isAuthenticated && currentUser;

  const handleClick = () => {
    if (isLoggedIn) {
      navigate("/dashboard");
    }
  };

  return (
    <Box
      sx={{
        position: "absolute", // ✅ THIS WAS MISSING

        // ✅ MOBILE → left aligned (only if NOT logged in)
        ...(isMobile && isLoggedIn
          ? {
              left: 8,
              transform: "none",
              alignItems: "flex-start",
            }
          : {
              left: "50%",
              transform: "translateX(-50%)",
              alignItems: "center",
            }),

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",

        height: "100%",
        pointerEvents: isLoggedIn ? "auto" : "none",
      }}
    >
      {/* Title */}
      <Typography
        variant="h3"
        onClick={handleClick}
        sx={{
          lineHeight: 1,
          cursor: isLoggedIn ? "pointer" : "default",
        }}
      >
        KSB-IT
      </Typography>

      {/* Subline */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          color: theme.palette.background.paper,
        }}
      >
        <School onClick={handleClick} sx={{ fontSize: 18, mr: 0.5 }} />
        <Typography variant="caption" onClick={handleClick}>
          TOOLBOX
        </Typography>
      </Box>
    </Box>
  );
}

export default memo(KsbItAppBarTitle);
